export const metadata = {
  title: 'Why Singaraa | Premium Indian Snacking',
  description: 'Discover why Singaraa stands out - premium peanuts, dry roasted for natural flavour, and protein-rich.',
};

import BenefitsHero from 'components/why/BenefitsHero';
import WhyStory from 'components/why/WhyStory';
import BenefitsGrid from 'components/why/BenefitsGrid';
import PageMeta from 'components/layout/PageMeta';

export default function WhySingaraaPage() {
  return (
    <main className="min-h-screen bg-singaraa-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      <BenefitsHero />
      <WhyStory />
      <BenefitsGrid />
    </main>
  );
}
